import * as React from 'react';
import { RssFeed } from '../../types';

interface RssFeedCmpProps {
  feed: RssFeed;
}

export default function RssFeedCmp(props: RssFeedCmpProps) {
  return (
    <React.Fragment>
      <h1>{props.feed.title}</h1>
    </React.Fragment>
  );
}
